const transientCodes = new Set([
  'ERR_NETWORK',
  'ECONNABORTED',
  'ETIMEDOUT',
  'PACKING_UPLOAD_STALLED',
]);
type TransferFailure = { code?: string; response?: { status?: number } };

/** Unknown errors are not proof of a completed transfer. Only these get one exact-identity check. */
export const uncertainPackingTransfer = (failure: unknown) => {
  const error = failure as TransferFailure | undefined;
  const status = error?.response?.status;
  return (
    status === 412 ||
    status === 408 ||
    (status != null && status >= 500 && status <= 599) ||
    (status == null && transientCodes.has(error?.code ?? ''))
  );
};

export const recordPackingTransferFailure = (
  failure: unknown,
  evidence: { packageId?: number; path?: string; bytes: number; loaded: number; elapsedMs: number },
) => {
  const error = failure as TransferFailure | undefined;
  // This is a logical route, never the signed upload URL or an Axios request/error object.
  void import('@admin-panel/observability')
    .then(({ addHttpBreadcrumb }) =>
      addHttpBreadcrumb({
        transport: 'axios',
        phase: 'error',
        request: {
          url: '/asset/upload/transfer',
          method: 'PUT/POST',
          body: {
            phase: 'transferring',
            ...evidence,
            category: transientCodes.has(error?.code ?? '')
              ? error!.code
              : error?.response?.status
                ? 'HTTP_ERROR'
                : 'OTHER',
          },
        },
        response: { status: error?.response?.status, durationMs: evidence.elapsedMs },
      }),
    )
    .catch(() => {
      /* Optional diagnostics must never change upload/recovery outcomes. */
    });
};
